import { useEffect, useState } from 'react';
import { useOrg } from '../orgs/org-context';
import { toast } from 'react-toastify';
import { listMedia, deleteMedia } from './media.api';
import MediaTile from './MediaTile';
import { apiFetch } from '../../api/api';

const MediaGrid = ({
  type,
  refreshKey,
  selectable = false,
  onSelect }) => {
  const { activeOrgId } = useOrg();
  const [loading, setLoading] = useState(true);
  const [media, setMedia] = useState([]);


  useEffect(() => {
    if (!activeOrgId) return;
    let mounted = true;

    async function load() {
      setLoading(true);
      try {
        const res = await apiFetch(`/media?organization=${activeOrgId}${type ? `&type=${type}` : ''}`);
        if (mounted) setMedia(res.items || []);
      } catch (err) {
        console.error(err);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    load();
    return () => { mounted = false; };
  }, [type, refreshKey, activeOrgId]);

  const deleteMedia = async (mediaItem) => {
      try {
        await apiFetch(`/media/${mediaItem._id}`, {
          method: 'DELETE'
        });

        setMedia(prev =>
          prev.filter(m => m._id !== mediaItem._id)
        );

        toast.success('Media deleted');
      } catch (err) {
        console.error(err);
        toast.error('Failed to delete media');
      }
    };


  if (loading) return <div>Loading…</div>;
  if (!media.length) return <div>No media uploaded yet.</div>;

  return (
    <div className="media-library-grid">
      {media.map(m => (
        <MediaTile
          key={m._id}
          media={m}
          onDelete={deleteMedia}
          selectable={selectable}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};

export default MediaGrid;
